import throttle from 'lodash.throttle';
//
ecFormBuilder.$inject = ['$compile', '$timeout', 'engineService', 'ecAnimationService'];

export default function ecFormBuilder($compile, $timeout, engineService, ecAnimationService) {
  return {
    restrict: 'E',
    controller: 'ecFormBuilderCtrl',
    controllerAs: 'vm',
    bindToController: true,
    require: 'ecFormBuilder',
    scope: {
      api: '=',
    },
    compile: elementCompile => {
      const elem = elementCompile[0];
      elem.classList.add('form--builder--element');

      return (scope, element, attrs, ecFormBuilderController) => {
        const unbinds = [];
        let cancelOptimize = angular.noop;
        ecFormBuilderController.allowInvalid =
          element[0]
            .closest('form')
            ?.getAttribute?.('ng-model-options')
            ?.search?.(/allowInvalid[ ]*:[ ]*true/) !== -1;

        unbinds.push(
          scope.$parent.$watch(attrs.api, api => {
            if (!api) {
              return;
            }
            if (!api.view || !api.data || !api.view.model || !api.data[api.view.model]) {
              throw new Error(`ecFormBuilder: params missing ${!api.view ? ' - api.view' : ''}${!api.data ? ' - api.data' : ''}${!api.view.model ? ' - api.view.model' : ''}${
                !api.data[api.view.model] ? ` - api.data['${api.view.model}']` : ''
              }
            `);
            }

            ecFormBuilderController._init(api);

            unbinds.push(
              ecFormBuilderController.events.on('fbFlash:register', ({ model, flashFn }) => {
                if (typeof flashFn !== 'function' || !ecFormBuilderController._flash[model]) {
                  return;
                }
                // ecFormBuilderController._flash[model] = flashFn;
                if (!Array.isArray(ecFormBuilderController._flash[model])) {
                  ecFormBuilderController._flash[model] = [];
                }
                ecFormBuilderController._flash[model].push(flashFn);
                handleFlashQueue();
              })
            );

            unbinds.push(
              ecFormBuilderController.events.on('fbFlash:unregister', ({ model, flashFn }) => {
                if (!Array.isArray(ecFormBuilderController._flash[model])) {
                  return;
                }
                // ecFormBuilderController._flash[model] = true;
                const index = ecFormBuilderController._flash[model].findIndex(fn => fn === flashFn);
                ecFormBuilderController._flash[model].splice(index, 1);
              })
            );

            function handleFlashQueue() {
              const { model, indexes } = ecFormBuilderController._flash.queue || {};
              if (!model) {
                return;
              }
              const flashFns = findModelIn(model, ecFormBuilderController._flash);
              flashFn && flashFns.forEach(flashFn => flashFn({ model, indexes }));
              // flashFn && flashFn({model, indexes});
            }

            compile(scope, element, ecFormBuilderController)
              .then(cancel => (cancelOptimize = cancel))
              .then(() => api.callback && api.callback(ecFormBuilderController))
              .then(() => {
                if (api && api.events && api.events.change) {
                  unbinds.push(
                    scope.$watch(
                      'vm.data',
                      (newValue, oldValue) => {
                        ecFormBuilderController.oldData = oldValue;
                        ecFormBuilderController.events.emit('change', ecFormBuilderController);
                      },
                      true
                    )
                  );
                }
              });
          })
        );

        scope.$on('$destroy', () => {
          unbinds.forEach(unbind => unbind());
          cancelOptimize();
          $timeout(() => ecFormBuilderController._destroy());
        });
      };
    },
  };

  // ///////////////////////////////////////////////////////////////////////////

  function compile(scope, element, ecFormBuilderController) {
    const elem = element[0];
    const cancelOptimize = ecFormBuilderController.options.optimize ? handleOptimizeFactory(scope, element[0]) : angular.noop;

    elem.flash = flash;

    return engineService(ecFormBuilderController)
      .then(({ modelsToInit }) => {
        initRegistersForCalc(modelsToInit);
      })
      .then(execPreloads)
      .then(waiting)
      .then(() => (elem.style.opacity = '0'))
      .then(appendHtml)
      .then(loadHtmlApi)
      .then(execScriptOnload)
      .then(() => scope.$evalAsync(() => ecFormBuilderController.events.emit('loaded', true)))
      .catch(console.error)
      .then(() => (elem.style.opacity = '1'))
      .then(() => cancelOptimize);

    // ///////////////////////////

    function waiting() {
      return new Promise(function(resolve) {
        scope.$evalAsync(() => {
          $timeout(() => {
            ecFormBuilderController.events.emit('opening', ecFormBuilderController);
            resolve();
          });
        });
      });
    }

    function appendHtml() {
      element.children().remove();
      try {
        $compile(element.append(angular.element(ecFormBuilderController._html)).contents())(scope);
      } catch (e) {
        throw new Error('Error during angular $compile: ', e);
      }
    }

    function loadHtmlApi() {
      const elem = element[0];
      ecFormBuilderController.openSection = openSection;
      ecFormBuilderController.recompileSection = recompileSection;
      ecFormBuilderController.flash = flash;

      function openSection(sectionName) {
        return new Promise((resolve, reject) => {
          if (!sectionName) {
            return reject(`ecFormBuilder.openSection Section "${sectionName}" no encontrada.`);
          }
          const eSection = elem.querySelector(`[data-section-optimize=${sectionName}]`);
          if (!eSection) {
            return reject(`ecFormBuilder.openSection(${sectionName}) section no encontrada`);
          }
          scope.vm.toggleSection[sectionName] = true;
          scope.vm.isSectionInViewPort[sectionName] = true; // forzamos también aunque no este visible
          scope.$evalAsync();
          ecAnimationService.scrollTo(elem, eSection.offsetTop, () => {
            $timeout(() => resolve(eSection), 300);
          });
        });
      }

      function recompileSection(sectionName) {
        return new Promise((resolve, reject) => {
          if (!sectionName) {
            return reject(`ecFormBuilder.compile Section "${sectionName}" no encontrada.`);
          }
          const eSection = elem.querySelector(`[data-section-optimize=${sectionName}]`);
          if (!eSection) {
            return reject(`ecFormBuilder.compile(${sectionName}) section no encontrada`);
          }
          if (!scope.vm.toggleSection[sectionName] || !scope.vm.isSectionInViewPort[sectionName]) {
            return;
          }

          scope.vm.isSectionInViewPort[sectionName] = false;
          scope.$evalAsync();

          ecAnimationService.scrollTo(elem, eSection.offsetTop, () => {
            $timeout(() => {
              scope.vm.isSectionInViewPort[sectionName] = true;
              scope.$evalAsync();
              resolve(true);
            }, 300);
          });
        });
      }
    }

    function flash({ section, model, indexes }) {
      ecFormBuilderController
        .openSection(section)
        .catch(() => elem) // si no encontramos sección puede ser un formulario simple, entonces buscamos en el elem completo
        .then(eSection => {
          const flashFns = findModelIn(model, ecFormBuilderController._flash); // buscamos si hay una directiva que encapsula el campo y le delegamos el "flash"

          if (Array.isArray(flashFns)) {
            flashFns.forEach(flashFn => {
              flashFn({ model, indexes });
            });
            return;
          }
          //if(!flashFns){// buscamos el campo directamente
          const eField = eSection.querySelector(`[data-x-path="${model}"]`);
          if (eField) {
            ecAnimationService.flash(eField);
          }
          //}
          //if(typeof flashFns === 'function') {flashFns.forEach(flashFn => flashFn({model, indexes}));}

          // ponemos en cola por si la directiva aun no esta lista
          /* ecFormBuilderController._flash.queue = { model, indexes };
          $timeout(() => {
            // si la directiva no responde, abandonamos
            if (ecFormBuilderController._flash.queue && ecFormBuilderController._flash.queue.model === model) {
              ecFormBuilderController._flash.queue = null;
            }
          }, 5000); */
        });
    }

    function initRegistersForCalc(registers) {
      Object.keys(registers).forEach(cur => initScopeValue(cur, ecFormBuilderController.data));

      function initScopeValue(model, data) {
        const m = model.split('.'),
          len = m.length,
          isArray = _model => registers[_model];
        let registerModel = '';
        for (let i = 0; i < len; i++) {
          const registerName = m[i];
          registerModel += registerModel ? `.${registerName}` : registerName;
          data[registerName] = data[registerName] || (isArray(registerModel) ? [] : {});
          if (isArray(registerModel)) {
            data[registerName] = data[registerName] || [];
            return;
          }
          data[registerName] = data[registerName] || {};
          data = data[registerName];
        }
      }
    }

    function execPreloads() {
      return Promise.all(
        ecFormBuilderController._preloads.map(fn => {
          return fn(ecFormBuilderController);
        })
      ).catch(err => {
        console.warn('ecFormBuilder. Error in "preload" promises: ', err);
      });
    }

    function execScriptOnload() {
      const script = (ecFormBuilderController.view.script || {}).onload;
      script && ecFormBuilderController.fn.eval(script);
    }

    // ///////////////////////////

    function handleOptimizeFactory(scope, elem) {
      const TIME_THROTTLE = 300,
        throttledOptimize = throttle(handleOptimize, TIME_THROTTLE);
      elem.addEventListener('click', throttledOptimize, true);
      elem.addEventListener('scroll', throttledOptimize);
      elem.addEventListener('ecCollapse:collapse', open, true);

      function open({ detail: { isOpen } = {} }) {
        const section = event.target.getAttribute('data-name');
        section && ecFormBuilderController.updateStateSection(section, isOpen);
      }

      return () => {
        throttledOptimize.cancel();
        elem.removeEventListener('click', throttledOptimize, true);
        elem.removeEventListener('scroll', throttledOptimize);
        elem.removeEventListener('ecCollapse:collapse', open, true);
      };

      function handleOptimize() {
        const eSections = Array.prototype.slice.call(elem.querySelectorAll('[data-section-optimize]')),
          isInViewportFn = isInViewportFnFactory(elem);
        //
        eSections.forEach(eSection => {
          const sectionName = eSection.getAttribute('data-section-optimize'),
            isInViewport = isInViewportFn(eSection);
          //
          if (isInViewport !== scope.vm.isSectionInViewPort[sectionName]) {
            scope.vm.isSectionInViewPort[sectionName] = isInViewport;
            scope.$evalAsync();
          }
        });

        function isInViewportFnFactory(elem) {
          const containerTop = elem.getBoundingClientRect().top,
            containerBottom = elem.getBoundingClientRect().bottom;
          return function isInViewportFn(eSection) {
            const top = eSection.getBoundingClientRect().top,
              bottom = eSection.getBoundingClientRect().bottom;
            return containerTop <= bottom && top <= containerBottom;
          };
        }
      }
    }
  }

  function findModelIn(model, obj = {}) {
    if (!model || typeof model !== 'string') {
      throw new Error(`ecFormBuilder.findModelIn model is not a string ${model}`);
    }
    const getParent = (str = '') =>
      str
        .split('.')
        .slice(0, -1)
        .reduce((acc, cur) => acc + (acc && cur ? '.' : '') + cur, '');
    let toFind = model,
      max = 15;
    while (toFind && --max) {
      if (obj[toFind]) {
        return obj[toFind];
      }
      toFind = getParent(toFind);
    }
    return false;
  }
} // fin directive
